import { Box, HStack, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { motion } from "motion/react";

const DURATION = 0.5;
const STEP = 0.25;

export const LoadingMessage = () => {
  const { t } = useTranslate();

  return (
    <Box px="sp-md" py="sp-sm" w="full">
      <HStack gap="sp-md">
        <div className="relative grid w-fit grid-cols-2 gap-sp-xs2">
          {[0, 1, 2, 3].map((i) => (
            <motion.span
              key={i}
              className="block size-si-xs4 bg-[#6B7C94]"
              animate={{ opacity: [0.3, 1] }}
              transition={{
                duration: DURATION,
                repeat: Number.POSITIVE_INFINITY,
                repeatType: "reverse",
                delay: i * STEP,
              }}
            />
          ))}
        </div>

        <KdsText size="subtitle-sm" color="text-bodyvariant">
          {t("openBrief.analysisInProgress")}
        </KdsText>
      </HStack>
    </Box>
  );
};
